export const WORKFLOWS_ROLE_SUBCONTRACTOR = 'sc';
export const WORKFLOWS_ROLE_GENERAL_CONTRACTOR = 'gc';
export const WORKFLOWS_ROLE_CONSTRUCTION_MANAGER = 'cm';
export const WORKFLOWS_ROLE_ARCHITECT = 'arch';

export const WORKFLOW_A = 'US';
export const WORKFLOW_B = 'EU';

export const USER_ROLE_ADMIN = 'project_admin';

export const WORKFLOWS_ADMIN_SPECIAL_OPTION_ALL_COMPANIES = '__all_companies__';
export const WORKFLOWS_ADMIN_SPECIAL_OPTION_ALL_TRADE_COMPANIES = '__all_trade_companies__';

export const ALL_USERS_SPECIAL_ID = 'all';

export const WORKFLOWS_ADMIN_ROLES_PREDEFINED_OPTIONS = {
  [WORKFLOWS_ROLE_SUBCONTRACTOR]: [
    {
      optionId: WORKFLOWS_ADMIN_SPECIAL_OPTION_ALL_COMPANIES,
      serverData: { type: 'company', id: 'all' },
    },
  ],
  [WORKFLOWS_ROLE_GENERAL_CONTRACTOR]: [
    {
      optionId: WORKFLOWS_ADMIN_SPECIAL_OPTION_ALL_TRADE_COMPANIES,
      serverData: { type: 'trade', id: 'General Contractor' },
    },
  ],
  [WORKFLOWS_ROLE_CONSTRUCTION_MANAGER]: [
    {
      optionId: WORKFLOWS_ADMIN_SPECIAL_OPTION_ALL_TRADE_COMPANIES,
      serverData: { type: 'trade', id: 'Construction Management' },
    },
  ],
  [WORKFLOWS_ROLE_ARCHITECT]: [
    {
      optionId: WORKFLOWS_ADMIN_SPECIAL_OPTION_ALL_TRADE_COMPANIES,
      serverData: { type: 'trade', id: 'Architecture' },
    },
  ],
};

export const ROLE_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};
